<template>
  <div class="forum">
    <div class="forum__top">
      <forum-navbar></forum-navbar>
    </div>

    <div class="forum__bottom">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import * as types from "../store/types";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      isLoggedIn: types.IS_LOGGED_IN
    })
  }
};
</script>

<style>
.forum {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
}

.forum__top {
  min-height: 72px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
  z-index: 9999;
}

.forum__bottom {
  flex: 1;
  overflow-y: auto;
  background-color: #f7f8fa;
}
</style>
